import { OnInit, Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { AppSettings } from 'src/app/app.settings';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { FiltroIncentivoBicicletaModel } from 'src/app/models/filtroIncentivoBicicleta.model';
import { IncentivosBicicletaModel } from 'src/app/models/IncentivosBicicleta.model';
import { Router } from '@angular/router';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-funcionarios-incentivo-bici',
    templateUrl: './funcionarios-incentivo-bici.component.html',
    styleUrls: ['./funcionarios-incentivo-bici.component.scss']
})

export class FuncionariosIncentivoBiciComponent implements OnInit {
    dominios: string[] = [DominiosService.DOMINIO_ESTADO_INCENTIVO_BICICLETA, DominiosService.DOMINIO_SEDE];
    listaDominios: DetalleDominio[];
    dominioEstado: DetalleDominio[];
    dominioSede: DetalleDominio[];
    dependencias: string[];
    filtroIncentivo: FiltroIncentivoBicicletaModel;
    compensaciones: IncentivosBicicletaModel[];



    

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private utilService: UtilService,
        private alertService: AlertService,
        public router: Router,
    ) {
        this.filtroIncentivo = new FiltroIncentivoBicicletaModel();


    }

    ngOnInit() {
        this.cargarFiltrosIniciales();
        this.consultarDominios();
        this.consultarDependencias();
        this.comsultarPlanesCompesacion();
    }
    
    private cargarFiltrosIniciales() {
        this.filtroIncentivo.estado = DominiosService.ESTADO_INCENTIVO_BICI_PENDIENTE;
        if (sessionStorage.getItem(ConstantesService.ROL_SESSION) !==  DominiosService.ROL_ADMINISTRADOR_TH) {
            this.filtroIncentivo.tipoDocumentoJefe = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
            this.filtroIncentivo.numDocumentoJefe = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
        }

    }


    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
        this.global.postGenerico(url, this.dominios).subscribe(
            data => {
                this.listaDominios = data;
                this.filtrarDominios(this.listaDominios);
                this.spinner.hide();
            }, err => {
                 this.utilService.cathException(err,this.alertService, this.spinner);
                // this.cathException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }

    public detalleCompensacion(tipoIdFuncionario: string , numeroIdFuncionario: string) {
        this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_INCENTIVO_BICICLETA]
            = { tipoIdFuncionario, numeroIdFuncionario};
        this.router.navigate(['incentivoBicicleta/gestion']);
    }

  

    
    /**
     * Metodo encargado de filtrar los dominios por cada una de las listas de seleccion
     * @function {filtrarDominios}
     * @param  {type} dominios: DetalleDominio[] {description}
     * @return {type} {description}
     */
    private filtrarDominios(dominios: DetalleDominio[]) {
        this.dominioEstado =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_ESTADO_INCENTIVO_BICICLETA);
        this.dominioSede =
            dominios.filter(dominio => dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_SEDE);
    }


    public comsultarPlanesCompesacion() {
        this.validarFiltros();
        this.spinner.show();
        const serviceProvider = 'consutarIncentivoFuncionarios';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),  this.urlService.hostAPI_FUNCIONARIOS );
        this.global.postGenerico(url, this.filtroIncentivo).subscribe(
            data => {
                this.compensaciones = data;
                this.spinner.hide();
            }, err => {
                 this.utilService.cathException(err, this.alertService , this.spinner);
            }
        );
    }



    private validarFiltros() {
        this.filtroIncentivo.sede = this.filtroIncentivo.sede  === 'undefined' ? undefined : this.filtroIncentivo.sede;
        this.filtroIncentivo.estado = this.filtroIncentivo.estado  === 'undefined' ? undefined : this.filtroIncentivo.estado;
        this.filtroIncentivo.dependencia = this.filtroIncentivo.dependencia  === 'undefined' ? undefined : this.filtroIncentivo.dependencia;
        this.filtroIncentivo.documentoONombre = this.filtroIncentivo.documentoONombre  === '' ? undefined : this.filtroIncentivo.documentoONombre;
    }

    private consultarDependencias() {
        this.spinner.show();
        const serviceProvider = 'consultarListaDependencia';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),  this.urlService.hostAPI_FUNCIONARIOS );
        this.global.getGenerico(url).subscribe(
            data => {
                this.dependencias = data;
            }, err => {
                 this.utilService.cathException(err, this.alertService);
            }
        );

    }
}
